import { CosmwasmWasmV1QuerySmartContractStateResponse, CosmwasmWasmV1QuerySmartContractStateService, CosmosBankV1beta1Balance, CosmosBankV1beta1QueryBalanceService, CosmosBankV1beta1QueryAllBalancesResponse, CosmosBankV1beta1QueryAllBalancesService, CosmosBankV1beta1QueryBalanceResponse, CosmosTxV1beta1GetTxResponse, CosmosTxV1beta1ServiceGetTxService, CosmosStakingV1beta1QueryValidatorDelegationsResponse, CosmosStakingV1beta1QueryValidatorDelegationsService } from "cosmes/protobufs"
import { RPC_URL } from "./Constants"
import { RpcClient } from "cosmes/client"

export async function querySmartContract(address: string, queryMsg: object) {
    const res = await new Promise<CosmwasmWasmV1QuerySmartContractStateResponse>(
        (resolve, rej) => RpcClient
            .newBatchQuery(RPC_URL)
            .add(
                CosmwasmWasmV1QuerySmartContractStateService,
                {
                    address,
                    queryData: new Uint8Array(Buffer.from(JSON.stringify(queryMsg)))
                },
                (err, res) => err ? rej(err) : resolve(res)
            )
            .send()
    )
    return JSON.parse(Buffer.from(res.data).toString())
}

export async function queryBalance(address: string, denom: string = "uluna") {
    const res = await new Promise<CosmosBankV1beta1QueryBalanceResponse>(
        (resolve, rej) => RpcClient

            .newBatchQuery(RPC_URL)
            .add(
                CosmosBankV1beta1QueryBalanceService,
                {
                    address,
                    denom
                },
                (err, res) => err ? rej(err) : resolve(res)
            )
            .send()
    )
    return Number(res.balance?.amount ?? 0)
}

export async function queryTx(txHash: string) {
    const res = await new Promise<CosmosTxV1beta1GetTxResponse>(
        (resolve, rej) => RpcClient

            .newBatchQuery(RPC_URL)
            .add(
                CosmosTxV1beta1ServiceGetTxService,
                {
                    hash: txHash
                },
                (err, res) => err ? rej(err) : resolve(res)
            )
            .send()
    )
    return res.txResponse
}

export async function queryDelegation(validatorAddr: string, limit: number, offset: number) {
    const res = await new Promise<CosmosStakingV1beta1QueryValidatorDelegationsResponse>(
        (resolve, rej) => RpcClient

            .newBatchQuery(RPC_URL)
            .add(
                CosmosStakingV1beta1QueryValidatorDelegationsService,
                {
                    validatorAddr,
                    pagination: {
                        offset: BigInt(offset),
                        limit: BigInt(limit)
                    }
                },
                (err, res) => err ? rej(err) : resolve(res)
            )
            .send()
    )
    return res
}
